export default "__VITE_ASSET__CBqcGzsi__"